/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author JiHoon Park
 * @contact jhpark@detech.co.kr
 * @date 2022-07-19
 * @brief EHP 회사/사업장/세부사업장 개발
 *
 ********************************************************************/
import React, { useState } from "react";
//recoil
import { useRecoilValue } from "recoil";
import { loadingBoxState, } from '../../recoil/menuState';
import { userInfoLoginState } from "../../recoil/userState";
// utils
import * as CONST from "../../utils/Const";
import clog from "../../utils/logUtils";
import * as CUTIL from "../../utils/commUtils";
//component
import AdminTree from "./AdminTree";
import NormalTree from "./NormalTree";
import AdminZone from "./zone/AdminZone";
import AdminSubZone from "./subZone/AdminSubZone";
import AdminRoom from "./room/AdminRoom";
import AdminDevice from "./device/AdminDevice";
/**
 * @brief EHP 운영 관리 컴포넌트 , 반응형 동작
 * @param -
 * @returns react components
 */
function AdminMain(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const isLoadingBox = useRecoilValue(loadingBoxState);
    //props
    const setParentPopWin = props.setPopWin;
    const tabMenuList = props.tabMenuList;
    const curTabMenu = props.curTabMenu;
    const setParentCurTabMenu = props.setCurTabMenu;
    //
    const [isMobile, setIsMobile] = useState(false);
    const [adminType, setAdminType] = useState("ZONE"); // ZONE, SUBZONE, ROOM, DEVICE
    // LIST, CREATE, UPDATE, DELETE, READ, BATCH
    const [workMode, setWorkMode] = useState("READ");
    const [nodata, setNodata] = useState();
    // option 선택 시  값 변경 액션
    function selectTabOption(optionElement) {
        const selectBox = optionElement.closest(".select");
        const selectedElement = selectBox.querySelector(".selected-value ");
        selectedElement.textContent = optionElement.textContent;
        var optionData = optionElement.getAttribute("data-value");
        selectedElement.setAttribute("data-value", optionData);
        clog("OPT VAL : " + optionElement.value);
        defaultCurTree();
        setParentCurTabMenu(JSON.parse(optionData)); // 탭 또는 모바일 경우
        //resetSearchParams();
    }
    function onClickTab(e) {
        var actTag = (e.target.tagName === "DIV") ? e.target : e.currentTarget;
        var tabStrInfo = actTag.getAttribute("data-value");
        var tabInfo = JSON.parse(tabStrInfo);
        //clog("TAB : " + JSON.stringify(tabInfo));
        //setAdminType(tabInfo.adminType);
        if (curTabMenu.tabType === "TAB_DEVICE") {
            setAdminType("ZONE");
            setWorkMode("READ");
            defaultCurTree();
        }
        else {
            defaultCurTree();
            setAdminType("ZONE");
            setWorkMode("READ");
        }
        setParentCurTabMenu(tabInfo);
    }
    const defaultCurTree = () => (setCurTree({
        company: { companyId: "", companyName: "" },
        zone: { zoneId: "", zoneName: "" },
        subZone: { subZoneId: "", subZoneName: "" },
        room: { roomId: "", roomName: "" },
        spg: { spgId: -1, spgName: "" },
        reload: false
    }));
    const [curTree, setCurTree] = useState({
        company: { companyId: "", companyName: "" },
        zone: { zoneId: "", zoneName: "" },
        subZone: { subZoneId: "", subZoneName: "" },
        room: { roomId: "", roomName: "" },
        spg: { spgId: -1, spgName: "" },
        reload: false
    });
    function handleCurTree(adminType, treeInfo) {
        //clog("IN SITETREE : handleCurTree : " + adminType);
        setAdminType(adminType);
        setCurTree(treeInfo);
    }
    clog("IN ADMINMAIN : INIT : " + curTabMenu.tabUrl + " : " + adminType + " : " + workMode + " : LOADING : " + isLoadingBox);
    return (React.createElement(React.Fragment, null,
        React.createElement("main", { className: "container admin-site", style: { "cursor": "default" } },
            React.createElement("section", { className: "content" },
                React.createElement("article", { className: `box list ${(isLoadingBox) ? "loading__box" : ""}` },
                    React.createElement("div", { className: `box__body ${(nodata <= 0) ? "nodata" : ""}` },
                        React.createElement("section", { className: "swiper-section" },
                            React.createElement("div", { className: "swiper-container mySwiper", style: { "cursor": "pointer" } },
                                React.createElement("div", { className: "swiper-wrapper" }, tabMenuList.map((tabMenu, idx) => (React.createElement("div", { key: `tab_${idx.toString()}`, className: `swiper-slide tab ${(tabMenu.tabId === curTabMenu.tabId) ? "on" : ""}`, onClick: (e) => onClickTab(e), "data-value": JSON.stringify(tabMenu) },
                                    React.createElement("p", null, tabMenu.tabName))))))),
                        React.createElement("div", { className: "d-sm-tab" },
                            React.createElement("div", { className: "select", onClick: (e) => CUTIL.onClickSelect(e, selectTabOption) },
                                React.createElement("div", { className: "selected" },
                                    React.createElement("div", { className: "selected-value" }, curTabMenu.tabName),
                                    React.createElement("div", { className: "arrow" })),
                                React.createElement("ul", null, tabMenuList.map((tabMenu, idx) => (React.createElement("li", { key: `tab_m_${idx.toString()}`, className: `option tab ${(tabMenu.tabId === curTabMenu.tabId) ? "on" : ""}`, "data-value": JSON.stringify(tabMenu) }, tabMenu.tabName)))))),
                        React.createElement("div", { id: "tab-1", className: "tabcontent current" },
                            (userInfo.loginInfo.role === CONST.USERROLE_ADMIN)
                                ? React.createElement(AdminTree, { isMobile: isMobile, tabType: curTabMenu.tabType, curTree: curTree, setCurTree: handleCurTree, adminType: adminType, setAdminType: setAdminType, workMode: workMode, setWorkMode: setWorkMode, setCurTabMenu: props.setCurTabMenu, setPopWin: props.setPopWin })
                                : React.createElement(NormalTree, { isMobile: isMobile, tabType: curTabMenu.tabType, curTree: curTree, setCurTree: handleCurTree, adminType: adminType, setAdminType: setAdminType, workMode: workMode, setWorkMode: setWorkMode, setCurTabMenu: props.setCurTabMenu, setPopWin: props.setPopWin }),
                            (curTabMenu.tabType === "TAB_ZONE") && (adminType === "ZONE") && React.createElement(AdminZone, { isMobile: isMobile, setIsMobile: setIsMobile, curTree: curTree, adminType: adminType, setCurTree: handleCurTree, setAdminType: setAdminType, workMode: workMode, setWorkMode: setWorkMode, setPopWin: props.setPopWin }),
                            (curTabMenu.tabType === "TAB_ZONE") && (adminType === "SUBZONE") && React.createElement(AdminSubZone, { isMobile: isMobile, setIsMobile: setIsMobile, curTree: curTree, adminType: adminType, setCurTree: handleCurTree, setAdminType: setAdminType, workMode: workMode, setWorkMode: setWorkMode, setCurTabMenu: props.setCurTabMenu, setPopWin: props.setPopWin }),
                            (curTabMenu.tabType === "TAB_ZONE") && (adminType === "ROOM") && React.createElement(AdminRoom, { isMobile: isMobile, setIsMobile: setIsMobile, curTree: curTree, adminType: adminType, setCurTree: handleCurTree, setAdminType: setAdminType, workMode: workMode, setWorkMode: setWorkMode, setCurTabMenu: props.setCurTabMenu, setPopWin: props.setPopWin }),
                            (curTabMenu.tabType === "TAB_DEVICE") && React.createElement(AdminDevice, { isMobile: isMobile, setIsMobile: setIsMobile, curTree: curTree, adminType: adminType, setCurTree: handleCurTree, setAdminType: setAdminType, workMode: workMode, setWorkMode: setWorkMode, setPopWin: props.setPopWin, curTabMenu: curTabMenu.tabType, setNodata: setNodata }))))))));
}
;
export default AdminMain;
